import React, { useEffect, useState } from "react";
import { View, Text } from "react-native";
import { CommonButton } from "../../components/buttons";
import { fonts } from "../../common/styles/fonts";
import { useNavigate } from "react-router-dom";
import { Header } from "../../components/Header";
import { InputField } from "../../components/InputField";
import { PasswordInput } from "../../components/PasswordInput";
import { colors } from "../../common/styles/colors";
import { CommonScreenCard } from "../../components/CommonScreenCard";
import useUniqueDispatch, {
  isData,
  isLoading,
  useSelector,
} from "../../utils/redux-utils";
import { RootState } from "../../store/root-reducer";
import { userLoginAction } from "../../store/user/action";
export const LoginPage = () => {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const disableButton = !email || !password;

  const userRequest = useSelector((store: RootState) => store.user);

  const [emailLoginToken, emailLogin] = useUniqueDispatch(
    userLoginAction.request
  );

  const isEmailLogging = isLoading(userRequest, emailLoginToken);

  const loginHandle = () => {
    emailLogin([{ identifier: email, password }]);
  };

  return (
    <CommonScreenCard>
      <Header
        onPressLeft={() =>
          navigate("../subscription/welcome", { replace: true })
        }
      />
      <Text style={[fonts.title, { marginBottom: 8 }]}>We need your Email</Text>
      <Text style={[fonts.mediumText_regular, { marginBottom: 51 }]}>
        text?
      </Text>
      <InputField
        value={email}
        containerStyle={{ marginBottom: 8 }}
        onChangeText={setEmail}
        placeholder="Email"
      />
      <PasswordInput
        containerStyle={{ height: 70 }}
        value={password}
        onChangeText={setPassword}
      />
      <Text
        style={[
          fonts.mediumText_regular,
          {
            marginBottom: 70,
            textDecorationLine: "underline",
            color: colors.noteGray,
          },
        ]}
        onPress={() => navigate("../subscription/forgot-password")}
      >
        Forgot your password?
      </Text>
      <CommonButton
        style={{ marginBottom: 32 }}
        textStyle={fonts.mediumText_bold}
        title="Next"
        isLoading={isEmailLogging}
        type={disableButton ? "black" : "blackFilled"}
        onPress={loginHandle}
        disabled={disableButton}
      />
      <View style={{ flexDirection: "row", marginBottom: 16 }}>
        <Text style={[fonts.mediumText_regular]}>Don’t have an account? </Text>
        <Text
          onPress={() => navigate("../subscription/register")}
          style={[fonts.mediumText_regular, { color: colors.violet }]}
        >
          Register
        </Text>
      </View>
      <View style={{ flexDirection: "row" }}>
        <Text style={[fonts.mediumText_regular]}>If any trouble </Text>
        <Text style={[fonts.mediumText_regular, { color: colors.violet }]}>
          Contact Support
        </Text>
      </View>
    </CommonScreenCard>
  );
};
